// extracted by mini-css-extract-plugin
module.exports = {"content":"paragraphe_content__3Ndm3","textJustify":"paragraphe_textJustify__gT7ak","textCenter":"paragraphe_textCenter__2Es-7"};